export default "__VITE_ASSET__CaAVgtkd__"